import { Create, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const CreateDoctoralSchoolCampaign = () => {
  return (
    <Create
      title="Създаване на кампания за докторантско училище"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm>
        <SaveForm />
      </SimpleForm>
    </Create>
  );
};

export default CreateDoctoralSchoolCampaign;
